import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { publicAssets } from '@utils/url.utils';
import { rem } from 'polished';
import CantFindYourDreamCarTemplate from './CantFindYourDreamCarTemplate';
export const CantFindYourDreamCarStyled = styled(CantFindYourDreamCarTemplate)`
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: linear-gradient(to top, ${({ theme }) => theme.colors.grey3}, white);
    position: relative;
    margin-top: ${rem('16px')};

    @media (min-width: ${breakpoints.sm}px) {
        border-radius: ${rem('12px')};
        border: ${rem('1px')} solid ${({ theme }) => theme.colors.grey3};
        margin: ${rem('16px')} ${rem(10)} 0 ${rem(10)};
        flex-direction: row;
        padding: ${rem('24px')};
        height: ${rem('280px')};
    }

    .content,
    .img {
        width: 100%;
        height: 100%;

        @media (min-width: ${breakpoints.sm}px) {
            width: 50%;
        }
    }

    .content {
        justify-content: space-between;
        display: flex;
        flex-direction: column;
        padding: ${rem('24px')};
        align-items: center;

        @media (min-width: ${breakpoints.sm}px) {
            padding: unset;
            align-items: self-start;
        }

        .txt {
            font-size: ${rem('22px')};
            font-weight: bold;
            display: flex;
            flex-direction: column;
            margin-bottom: ${rem('15px')};

            @media (min-width: ${breakpoints.sm}px) {
                margin-bottom: unset;
                max-width: ${rem('300px')};
            }
        }
    }

    .img {
        background-position: right;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('${publicAssets('/images/cantFindYourDreamCar_mob.png')}');
        height: ${rem('300px')};

        @media (min-width: ${breakpoints.sm}px) {
            height: inherit;
            position: absolute;
            z-index: 9999;
            top: 0;
            right: 0;
            background-image: url('${publicAssets('/images/cantFindYourDreamCar.png')}');
        }
    }
`;
